import { environment } from '@/shared/enviroment/environment';
import { CategoryCardsResponse, CategoryResponseDto } from '../dto/category.dto';
import axios from 'axios';
import { ApiService } from '@/shared/service/Apiservice';

class CategoryService {
  async getServiceOptions(): Promise<any> {
    return this.__Apiservice.getRequest('service-options', {}, {
      apiRoot: this.apiRootServer,
    });
  }
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async getAllCategories(): Promise<CategoryResponseDto> {
    return this.__Apiservice.getRequest('categories', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async getCategoryCards(): Promise<CategoryCardsResponse> {
    return this.__Apiservice.getRequest('category-cards', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async getCategoryBySlug(slug: string): Promise<CategoryResponseDto> {
    return this.__Apiservice.getRequest(`categories/${slug}`, {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async getCategoryTree(): Promise<CategoryResponseDto> {
    return this.__Apiservice.getRequest('categories/tree', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  
  async getServices(): Promise<CategoryResponseDto> {
    return this.__Apiservice.getRequest('services', {}, {
      apiRoot: this.apiRootServer,
    });
  }
}


const categoryService = new CategoryService();
export default categoryService;